/* Renders a backend-secured image endpoint that requires a Bearer token.
   Fetches the URL with Authorization header, converts to blob URL,
   revokes on unmount. Falls back to a small "loading…" state.  */
import { useEffect, useState } from "react";
import { api } from "../../../lib/apiClient";

export default function AuthedImage({ path, alt = "", className, style, testId, onLoad }) {
  const [objUrl, setObjUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let created = null;
    setErr(false);
    setObjUrl(null);
    if (!path) return () => {};
    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}${path}`,
          { headers: { Authorization: `Bearer ${api.token()}` } },
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        if (cancelled) return;
        created = URL.createObjectURL(blob);
        setObjUrl(created);
      } catch (_e) { if (!cancelled) setErr(true); }
    })();
    return () => {
      cancelled = true;
      if (created) URL.revokeObjectURL(created);
    };
  }, [path]);

  if (err) {
    return (
      <div data-testid={testId ? `${testId}-error` : undefined}
           className={className}
           style={{ ...(style || {}), background: "rgba(220,38,38,0.10)", color: "#FCA5A5",
                    display: "grid", placeItems: "center", fontSize: 10, textAlign: "center" }}>
        image unavailable
      </div>
    );
  }
  if (!objUrl) {
    return (
      <div className={className}
           style={{ ...(style || {}), background: "rgba(255,255,255,0.03)",
                    display: "grid", placeItems: "center", color: "#9AA5A0", fontSize: 10 }}>
        …
      </div>
    );
  }
  return <img data-testid={testId} src={objUrl} alt={alt} className={className}
              style={style} onLoad={onLoad} />;
}
